import React from 'react'
import { MenuItem, Select } from '@material-ui/core'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import FlexRow from '../../../../components/molecules/FlexRow'

const useStyles = makeStyles(() => ({
  select: {
    fontSize: 'var(--font-size-xs)',
    '&:before': {
      display: 'none'
    },
    '&:after': {
      display: 'none'
    },
    '&:hover:not(.Mui-disabled):before': {
      display: 'none'
    },
    '& .MuiSelect-select:focus': {
      backgroundColor: 'transparent'
    },
    '& .MuiSelect-select': {
      fontSize: 'var(--font-size-xs)',
      paddingBottom: 0
    }
  }
}))

function OrderBy ({ value, onChange }) {
  const classes = useStyles()

  return (
    <FlexRow className='font-size-xs gap-sm'>
      <span>Order By</span>
      <Select
        value={value}
        onChange={e => {
          onChange(e.target.value)
        }}
        className={classes.select}
        disableUnderline
      >
        <MenuItem value='lastActivity'>Latest Activity</MenuItem>
        <MenuItem value='createdDate'>Date Created</MenuItem>
        <MenuItem value='name'>Name</MenuItem>
      </Select>
    </FlexRow>
  )
}

OrderBy.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func
}

export default OrderBy
